export const companyProfile = () => {
  return {
    company_profile: 'Perfil de Compañía',
    info_insurance: 'Información de Compañía y Seguros',
    clients_trades: 'Clientes y Comercios',
    service_area: 'Área de Servicio',
    users: 'Usuarios',
    continue: 'Continuar',
    yes: 'Si',
    no: 'No',
    none: 'Ninguno',
    weekdays: 'Lunes - Viernes',
    weekend: 'Sábado - Domingo',
    saturday: 'Sábado',
    sunday: 'Domingo',
    labels: {
      company_legal: 'Nombre de Compañía',
      upload: 'Cargar logo de la compañía',
      country: 'País(es) de Operación',
      entity: 'Entidad Legal',
      business_hours: 'Teléfono de horario laboral',
      dba: 'Compañía DBA',
      full_dba: 'Compañía (En representación de)',
      after_hours: 'Teléfono para horario extendido',
      headquarters: 'Matriz de Compañía',
      dispatch: 'Correo para despacho de Orden de Trabajo',
      invoice_email: 'Correo para Citas/Factuación',
      address: 'Dirección de la compañía',
      days_operation: 'Días laborables',
      times_operation: 'Horario laboral',
      days_operation_after: 'Días laborables con horario extendido',
      times_operation_after: 'Horario extendido',
      upload_file: 'Cargar archivo',
      ein: 'Número de identificación del empleador (o equivalente)',
      state: 'Estado(s) que la Compañía está registrada',
      contractor_licence: 'Licencia de contratista #',
      coi: 'Política COI #',
      comp: 'Póliza de compensación a empleados #',
      bank: 'Nombre de Banco',
      account_number: 'Número de cuenta bancaria',
      routing_number: 'Número de ruta bancaria',
      trades: 'Elija su(s) oficio(s)',
      standard_rate: 'Tarifa estándar ($/hora)',
      emergency_rate: 'Tarifa de emergencia ($/hora)',
      travel_cost: 'Costo de mobilización ($)',
      select_in_map:
        'Selecciona tu área de servicio usando los selectores de abajo.',
      no_users:
        'No ha agregado ningún usuario para su compañía. {v1} no va a poder enviar su trabajo sin un área de servicio.',
      incomplete_users: 'Quedan usuarios sin crear. ¿Desea continuar?',
      web_users: 'Usuarios del Portal Web',
      add_web_users: 'Agregar Más Usuarios del Portal Web',
      app_users: 'FieldTech Usuarios Móviles',
      add_app_users: 'Agregar Más Usuarios Móviles FTC',
      created: 'Creado',
      add_service_area: 'Agregar área de servicio',
      loading: 'Cargando archivo...',
      email: 'Correo de la Compañía',
      company_website: 'Página Web de la compañía'
    },
    placeholder: {
      company_legal: 'Ingrese el nombre de compañía',
      company_website: 'Ingrese la página Web de la compañía',
      country: 'Seleccionar',
      entity: 'Seleccionar',
      business_hours: 'Ingrese el teléfono para horario normal',
      dba: 'Ingrese la compañía DBA',
      after_hours: 'Ingrese el teléfono para horario extendido',
      headquarters: 'Seleccionar',
      dispatch: 'Ingrese correo',
      invoice_email: 'Ingrese correo para Citas/Facturación',
      address: 'Ingrese la dirección',
      ein: 'Ingrese el número de identificación del empleador',
      select_required: 'Seleccionar',
      contractor_licence: 'Ingrese licencia #',
      coi: 'Ingrese el número de COI',
      comp: 'Ingrese el número de póliza de compensaciones',
      bank: 'Ingrese nombre del banco',
      account_number: 'Ingrese el número de cuenta',
      routing_number: 'Ingrese el número de ruta',
      month: 'Mes',
      year: 'Año',
      rate: 'Ingrese tarifa $/hora',
      cost: 'Ingrese costo $',
      no_service_area: 'Agregue su(s) área(s) de servicio',
      select_state: 'Seleccionar Estado',
      select_territory: 'Seleccionar Territorio',
      select_city: 'Seleccionar Ciudad',
      select_county: 'Seleccionar Condado',
      select_country: 'Seleccionar País',
      select_zip: 'Seleccionar código zip',
      search: 'Buscar',
      search_address: 'Buscar Dirección',
      mile_radius: 'radio en millas',
      no_geo_coordinates: 'Las Geocoordenadas estarán disponibles pronto',
      open: 'Abierto',
      close: 'Cerrado'
    },
    message: {
      company_profile:
        'Puede volver en cualquier momento y editar su información.'
    },
    upload: {
      w9: 'Cargar su forma W9',
      coi: 'Cargar su certificado de seguro',
      comp: 'Cargar su compensación para empleados',
      void: 'Cheque bancario anulado'
    },
    questions: {
      support_hours: 'Provee soporte 24 / 7?',
      trucks: '¿Cuántos camiones propiedad de la compañía tiene?',
      field_employees: '¿Cuantos empleados de campo?',
      administrative_employees: '¿Cuántos empleados administrativos?',
      years: '¿Cuántos años en el mercado ha estado su compañía?',
      subcontractors: '¿Utiliza subcontratistas?',
      coi: '¿Cuándo expira su COI?',
      comp: 'Fecha de vencimiento de la compensación a trabajadores',
      serve: '¿A qué cliente(s) brinda servicios?'
    },
    clients: {
      commercial: 'Comercial',
      industrial: 'Industrial',
      educational: 'Educativo',
      residential: 'Residencial',
      property_preservation: 'Preservación de la Propiedad',
      medical: 'Médico'
    },
    trades: {
      beverage_equipment: 'Equipo de bebidas',
      disaster_relief: 'Ayuda en casos de desastre',
      doors: 'Puertas',
      fire_systems: 'Sistemas contra incendios',
      floor_care: 'Cuidado de suelos y limpieza',
      flooring: 'Piso - Reparar/Reemplazar',
      fuel_systems: 'Sistemas de combustible',
      gates: 'Puertas/Rejas',
      glass: 'Vidrio',
      kitchen_quipment: 'Equipamiento de cocina',
      landscaping: 'Paisajismo',
      locks: 'Cerraduras',
      parking_lot: 'Estacionamiento',
      pest_control: 'Control de plagas',
      refrigeration: 'Refrigeración',
      roof: 'Techo',
      snow_removal: 'Remoción de nieve',
      electrical: 'Eléctrico',
      plumbing: 'Plomería',
      hvac: 'Climatización',
      general_maintenance: 'Mantenimiento General',
      appliances: 'Electrodomésticos',
      painting: 'Pintura',
      carpentry: 'Carpintería'
    },
    services: {
      beverage_equipment: 'Equipo de bebidas',
      disaster_relief: 'Ayuda en casos de desastre',
      dock: 'Muelle/Niveladores',
      overhead_doors: 'Puertas basculantes',
      doors: 'Puertas',
      entrance_doors: 'Puertas de entrada',
      fire_alarm: 'Alarma de incendio',
      fire_extinguisher: 'Extintor de incendios',
      fire_systems: 'Sistemas contra incendios',
      fire_back_flow: 'Sistemas contra incendios - Flujo inverso',
      floor_care: 'Cuidado del suelo',
      janitorial: 'Conserjería',
      windows: 'Ventanas',
      flooring: 'Instalación de pisos',
      automatic_tank: 'Indicador de tanque automático',
      compressed_gas: 'Gas Natural Comprimido',
      fuel_dispenser: 'Dispensador de combustible',
      fuel_environmental: 'Combustible Ambiental',
      underground_storage: 'Tanque de almacenamiento subterráneo',
      gates: 'Puertas/Rejas',
      glass: 'Vidrio',
      film: 'Láminas de seguridad',
      kitchen_equipment: 'Equipamiento de cocina',
      exhaust_cleaning: 'Limpieza de campana extractora',
      landscaping: 'Paisajismo/jardín',
      hardscaping: 'Paisajismo/permanente',
      irrigation: 'Riego',
      locks: 'Cerraduras',
      safes: 'Cajas fuertes',
      parking_lot: 'Estacionamiento',
      pest_control: 'Control de plagas',
      refrigeration: 'Refrigeración',
      roof: 'Techo',
      snow_removal: 'Remoción de nieve',
      exterior_lighting: 'Iluminación exterior',
      interior_lighting: 'Iluminación interior',
      exterior_signage: 'Señalización exterior',
      major_electrical: 'Electricidad mayor',
      generators: 'Generadores',
      minor_electrical: 'Electricidad menor',
      back_flow: 'Flujo de retorno',
      minor_plumbing: 'Plomería menor',
      water_systems: 'Sistemas de agua',
      grease_traps: 'Trampas de Grasa',
      septic: 'Séptico',
      well_systems: 'Sistemas de pozos',
      major_plumbing: 'Plomería mayor',
      water_heater: 'Calentador de agua',
      hvac: 'Climatización',
      temperature_controls: 'Controles de temperatura',
      concrete: 'Concreto',
      general_maintenance: 'Mantenimiento General',
      blinds: 'Persianas',
      fencing: 'Cercado/Puertas',
      paint: 'Pintura',
      foundation: 'Cimientos',
      power_washing: 'Lavado a presión',
      cabinets: 'Gabinetes/Encimeras',
      inspections: 'Inspecciones',
      fireplace: 'Chimeneas',
      appliances: 'Electrodomésticos',
      exterior_painting: 'Pintura exterior',
      interior_painting: 'Pintura de interiores',
      general_carpentry: 'Carpintería General',
      cabinets_carpentry: 'Gabinetes',
      trim_work: 'Trabajo de recorte',
      tile: 'Mosaico'
    },
    area: {
      city: 'Ciudad',
      zip: 'Zip',
      county: 'Condado'
    },
    error: {
      company_website: 'La página Web introducida no es válida',
      email: 'El Correo Electrónico introducido no es válido',
      file_size: 'El tamaño del archivo no debe ser mayor a {size}MB',
      file_resolution: 'La resolución del archivo debe ser al menos {res}px',
      file_aspect_ratio: 'La relación de aspecto del archivo debe estar entre 1:1 y 16:9',
      hours_operation: 'El horario laboral es incorrecto',
      general_error:
        'Ha ocurrido un problema al completar su petición. Por favor contacte a su administrador',
      phone: 'Please enter a valid phone number'
    }
  }
}
